/**
 * @generated SignedSource<<4b10ccd13833f9d90fd210c98412df8d>>
 * @relayHash 9d195649daf7f0208dce8ad9b88e654a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 950cd1e7e24b5c855d8a57567a3d0ef4e2d629004966e4dc33cecd76d8f7d440

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "950cd1e7e24b5c855d8a57567a3d0ef4e2d629004966e4dc33cecd76d8f7d440",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
